// extracted by mini-css-extract-plugin
export default {"form":"save-quotes-modal-module__form--bgv"};